__turbopack_context__.v({
  "className": "gtplanar_5124216-module__rxFq7W__className",
  "variable": "gtplanar_5124216-module__rxFq7W__variable",
});
